import {
  UserInfo,
  UserInfoServer,
  UsersListServer,
  UsersListTransformed,
} from '../store/types';

export const adapteUserInfo = (res: UserInfoServer): UserInfo => ({
  id: res.id,
  email: res.email,
  phone: res.phone,
  name: res.name,
  role: res.role,
  isBanned: res.is_banned,
  created: res.created,
  balance: res.balance,
  groupId: res.group_id
});

export const adapteUsersList = ({ items, count }: UsersListServer): UsersListTransformed => ({
  items: items.map(adapteUserInfo).sort((a, b) => a.id - b.id),
  count,
});
